import { render, staticRenderFns } from "./storeOrderCartFee.vue?vue&type=template&id=42bcc28e&scoped=true"
import script from "./storeOrderCartFee.vue?vue&type=script&lang=js"
export * from "./storeOrderCartFee.vue?vue&type=script&lang=js"
import style0 from "./storeOrderCartFee.vue?vue&type=style&index=0&id=42bcc28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bcc28e",
  null
  
)

export default component.exports